import { useCallback, useState, type MouseEvent, type KeyboardEvent } from 'react';

const useToggle = (initialState: boolean = false): [boolean, (e: MouseEvent<HTMLOrSVGElement> | KeyboardEvent<HTMLOrSVGElement>) => void] => {
  const [state, setState] = useState<boolean>(initialState);

  const toggle = useCallback((e: MouseEvent<HTMLOrSVGElement> | KeyboardEvent<HTMLOrSVGElement>) => {
    e.stopPropagation();
    setState((val: boolean) => !val)
  }, []);

  return [state, toggle]
};

export default useToggle;
